import React from 'react';
import '../App.css';
import Headerappprivateadmin from './/headerappprivateadmin'
import { Bodyapphomebodyadmincambios} from './/bodyapphomebodyadmincambios'
import { Footerappprivateadmin } from './/footerappprivateadmin'
import withRouter from './/withRouter'
class Bodyappadmincambios extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
    if(window.localStorage.getItem('MY_APP_STATE_AUTHCODE') == ''){
       window.location = ('/')
    }
  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivateadmin/>
        <Bodyapphomebodyadmincambios/>
        <Footerappprivateadmin/>
      </div>
    );
  }
}
export default withRouter(Bodyappadmincambios);